module.exports = __webpack_public_path__ + "d3ddd6025a06a78535b0d432d14905bf.svg";